export default () => {
  document.querySelectorAll(".js-text-cards__clickable").forEach((el) => {
    const url = el.dataset.location;

    if (url) {
      el.addEventListener("click", () => {
        window.location = url;
      });
    }
  });
};
